import { storageLocal } from "@pureadmin/utils";
import { defineStore } from "pinia";

import { store } from "@/store";
import { useChannelStoreHook } from "@/store/modules/channel";
import { useHttpStoreHook } from "@/store/modules/http";
import { useUserStoreHook } from "@/store/modules/user";

import getChannelConfig from "../channels";
import { getChannelKeyByHost, getChannelKeyByHostAlternative } from "../config";

export const useYChannelStore = defineStore({
  id: "y-channel",
  state: () => ({
    channel: null,
    configs: null,
    toAlternativeChannels: [],
    extConfigs: null
  }),
  actions: {
    async init(query) {
      const channelStore = useChannelStoreHook();
      let channel = "";
      if (query?.channel) {
        channel = query.channel;
      } else {
        const channelKeyByHost = getChannelKeyByHost();
        // const channelKeyByHostAlternative = getChannelKeyByHostAlternative();
        // if (!this.channel && channelKeyByHostAlternative) {
        //   return false;
        // }
        channel = channelKeyByHost;

        if (!channel) {
          channel = await channelStore.getSessionChannel();
        }
      }
      // this.hoteluxDefaultInfo(query?.channel);
      this.channel = this.channel || channel;

      if (this.channel) {
        useHttpStoreHook().setHeader("y-platform-channel", this.channel);
        await channelStore.getChannel(this.channel);
        const channelConfig = getChannelConfig(this.channel);
        if (channelConfig) {
          channelConfig.init?.();
          this.configs = channelStore.channel
            ? { ...channelConfig.configs, ...channelStore.channel }
            : channelConfig.configs ?? {};
          this.extConfigs = channelConfig;
        }
        useUserStoreHook().SET_CURRENCY(
          channelStore.channel?.currency ?? "CNY"
        );
      }
    },
    getChannelDefaultLanguage() {
      const { channel: channelData } = useChannelStoreHook();
      let locale =
        channelData?.i18n?.languages[0] || storageLocal().getItem("y-locale");
      if (
        this.configs?.languages &&
        !this.configs?.languages.some(item => item.value === locale)
      ) {
        locale = this.configs.languages[0].value;
      }
      return locale;
    },
    isNeedChooseChannel() {
      const channelKeyByHostAlternative = getChannelKeyByHostAlternative();
      return !this.channel && channelKeyByHostAlternative;
    },
    /**
     * 获取当前环境的偏好配置上下文
     * 专门用于生成传给 userStore.syncPreferences 的参数
     */
    getPreferenceOptions() {
      // const channel = this.channel;
      const configs = this.configs;

      // const isHoteluxSystem =
      //   window.location.host.includes("hotel.hotelux.com") ||
      //   ["hotelux", "hoteluxjp"].includes(channel);

      const enforcedDefaultLanguage = this.getChannelDefaultLanguage();
      // if (isHoteluxSystem) {
      //   const isJpEnv =
      //     channel === "hoteluxjp" || window.location.host.includes("hoteluxjp");

      //   if (isJpEnv) {
      //     enforcedDefaultLanguage =
      //       getChannelConfig("hoteluxjp")?.configs?.defaultLanguage || "ja";
      //   } else {
      //     enforcedDefaultLanguage =
      //       getChannelConfig("hotelux")?.configs?.defaultLanguage || "en";
      //   }
      // }

      return {
        defaultCurrency: configs?.currency,
        channelConfig: configs,
        // isEnforcedLocale: isHoteluxSystem,
        enforcedDefaultLanguage: enforcedDefaultLanguage
      };
    },
    async checkHasAlternativeChannel() {
      const channel = getChannelKeyByHostAlternative();
      if (channel) {
        this.toAlternativeChannels = channel.map(item => {
          return {
            label: item,
            value: item
          };
        });
      }
      return channel;
    },
    SET_CHANNEL(channel) {
      this.channel = channel;
      useHttpStoreHook().setHeader("y-platform-channel", this.channel);
    }
    // hoteluxDefaultInfo(channel) {
    //   let HLDefault = getChannelConfig("hotelux");
    //   //线上hotelux,判断未登录进入首页默认语言en,渠道走hotelux
    //   if (window.location.host.includes("hotel.hotelux.com")) {
    //     if (channel == "hoteluxjp") {
    //       HLDefault = getChannelConfig("hoteluxjp");
    //     }
    //     useUserStoreHook().changeLanguage(HLDefault.configs?.defaultLanguage);
    //     this.channel = HLDefault.configs?.key;
    //   } else {
    //     // dev
    //     if (channel === "hoteluxjp" || channel === "hotelux") {
    //       HLDefault = getChannelConfig(channel);
    //       this.channel = HLDefault.configs?.key;
    //       useUserStoreHook().changeLanguage(HLDefault.configs?.defaultLanguage);
    //     } else {
    //       this.channel = channel;
    //     }
    //   }
    // }
  }
});

export function useYChannelStoreHook() {
  return useYChannelStore(store);
}
